import { AccountTypeBadge } from '@/modules/projects/components/AccountTypeBadge'
import { AccountNumber } from '@/modules/projects/components/Workbench/AccountNumber'
import {
  accountTypePill,
  accountTypeWord,
} from '@/modules/projects/components/Workbench/accounts'
import type { Account } from '@/modules/projects/components/Workbench/types'
import { cn } from '@/utils'

export const CHOICE =
  'w-full cursor-pointer rounded px-2 py-1 text-left text-sm hover:bg-accent'

interface ChoiceProps {
  account: Account
  picked: boolean
  onPick: (accountId: string) => void
}

export const Choice = ({ account, picked, onPick }: ChoiceProps) => (
  <button
    type="button"
    data-account-choice={account.id}
    onClick={() => onPick(account.id)}
    className={cn(CHOICE, 'flex items-center gap-2', picked && 'font-semibold')}
  >
    <AccountNumber numbers={account.numbers} />
    <AccountTypeBadge type={accountTypePill(account.accountType)} size="xs">
      {accountTypeWord(account.accountType)}
    </AccountTypeBadge>
  </button>
)
